import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gradient-to-br from-white via-indigo-50 to-purple-50 rounded-xl sm:rounded-2xl shadow-lg sm:shadow-2xl p-4 sm:p-6 lg:p-8 border border-indigo-100" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 sm:mb-6 gap-3 sm:gap-0" }
const _hoisted_3 = { class: "bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-4 sm:px-5 py-2 sm:py-2.5 rounded-lg sm:rounded-xl text-xs sm:text-sm font-bold shadow-lg hover:shadow-xl transition-shadow self-start sm:self-auto" }
const _hoisted_4 = { class: "bg-white rounded-lg sm:rounded-xl shadow-md sm:shadow-lg p-3 sm:p-4 lg:p-6 border border-slate-100" }
const _hoisted_5 = { class: "mt-4 sm:mt-6 grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4" }
const _hoisted_6 = { class: "bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-lg p-3 sm:p-4 border border-indigo-200" }
const _hoisted_7 = { class: "flex items-center gap-2 sm:gap-3" }
const _hoisted_8 = { class: "min-w-0 flex-1" }
const _hoisted_9 = { class: "text-sm sm:text-base font-bold text-indigo-900 truncate" }
const _hoisted_10 = { class: "bg-gradient-to-br from-amber-50 to-amber-100 rounded-lg p-3 sm:p-4 border border-amber-200" }
const _hoisted_11 = { class: "flex items-center gap-2 sm:gap-3" }
const _hoisted_12 = { class: "min-w-0 flex-1" }
const _hoisted_13 = { class: "text-sm sm:text-base font-bold text-amber-900 truncate" }
const _hoisted_14 = { class: "bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg p-3 sm:p-4 border border-purple-200" }
const _hoisted_15 = { class: "flex items-center gap-2 sm:gap-3" }
const _hoisted_16 = { class: "min-w-0 flex-1" }
const _hoisted_17 = { class: "text-xs sm:text-sm font-bold text-purple-900 truncate" }

import { computed } from "vue";
import VChart from "vue-echarts";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import { ProductosMasVendidosInterface } from "../interfaces/productosMasVendidos.interface";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductosMasVendidosChart',
  props: {
    data: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

use([
  CanvasRenderer,
  BarChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
]);

const props = __props;

const chartOption = computed(() => {
  const productos = props.data?.data || [];

  const nombres = productos.map((p) => p.producto.nombreProducto);
  const cantidades = productos.map((p) => p.cantidadVendida);
  const totales = productos.map((p) => parseFloat(p.totalVentas));

  // Configuración responsiva
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 640;
  const isTablet = typeof window !== 'undefined' && window.innerWidth < 1024;

  return {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
        shadowStyle: {
          color: "rgba(99, 102, 241, 0.1)",
        },
      },
      backgroundColor: "rgba(255, 255, 255, 0.96)",
      borderColor: "#6366f1",
      borderWidth: 2,
      padding: isMobile ? 10 : 12,
      textStyle: {
        color: "#1e293b",
        fontSize: isMobile ? 11 : 13,
      },
      extraCssText: 'box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-radius: 8px;',
      formatter: (params: any) => {
        const cantidad = params[0];
        const total = params[1];
        return `<div style="min-width: ${isMobile ? '180px' : '220px'};">
                  <strong style="color: #1f2937; font-size: ${isMobile ? '12px' : '14px'}; display: block; margin-bottom: ${isMobile ? '8px' : '10px'};">${cantidad.name}</strong>
                  <div style="display: flex; flex-direction: column; gap: ${isMobile ? '6px' : '8px'};">
                    <div style="display: flex; align-items: center; gap: ${isMobile ? '6px' : '8px'};">
                      <span style="display: inline-block; width: ${isMobile ? '8px' : '10px'}; height: ${isMobile ? '8px' : '10px'}; background: #6366f1; border-radius: 50%;"></span>
                      <span style="color: #6b7280; flex: 1; font-size: ${isMobile ? '11px' : '13px'};">Cantidad:</span> 
                      <strong style="color: #6366f1; font-size: ${isMobile ? '12px' : '14px'};">${cantidad.value}</strong>
                    </div>
                    <div style="display: flex; align-items: center; gap: ${isMobile ? '6px' : '8px'};">
                      <span style="display: inline-block; width: ${isMobile ? '8px' : '10px'}; height: ${isMobile ? '8px' : '10px'}; background: #f59e0b; border-radius: 50%;"></span>
                      <span style="color: #6b7280; flex: 1; font-size: ${isMobile ? '11px' : '13px'};">Total:</span> 
                      <strong style="color: #f59e0b; font-size: ${isMobile ? '12px' : '14px'};">S/ ${total.value.toFixed(2)}</strong>
                    </div>
                  </div>
                </div>`;
      },
    },
    legend: {
      data: ["Cantidad Vendida", "Total Ventas (S/)"],
      top: isMobile ? 10 : 15,
      itemGap: isMobile ? 15 : 30,
      itemWidth: isMobile ? 18 : 24,
      itemHeight: isMobile ? 12 : 16,
      textStyle: {
        fontSize: isMobile ? 10 : isTablet ? 11 : 13,
        fontWeight: 600,
        color: "#334155",
      },
      icon: 'roundRect',
      orient: isMobile ? 'horizontal' : 'horizontal',
    },
    grid: {
      left: isMobile ? "8%" : "5%",
      right: isMobile ? "10%" : "8%",
      bottom: "5%",
      top: isMobile ? 50 : 60,
      containLabel: true,
    },
    xAxis: {
      type: "value",
      splitLine: {
        lineStyle: {
          color: "#e2e8f0",
          type: "dashed",
        },
      },
      axisLabel: {
        color: "#64748b",
        fontSize: isMobile ? 9 : isTablet ? 10 : 12,
      },
      axisLine: {
        lineStyle: {
          color: "#cbd5e1",
        },
      },
    },
    yAxis: {
      type: "category",
      data: nombres,
      inverse: true,
      axisLabel: {
        color: "#334155",
        fontSize: isMobile ? 9 : isTablet ? 10 : 12,
        fontWeight: 500,
        interval: 0,
        width: isMobile ? 80 : isTablet ? 100 : 130,
        overflow: "truncate",
      },
      axisLine: {
        lineStyle: {
          color: "#cbd5e1",
        },
      },
      axisTick: {
        show: false,
      },
    },
    series: [
      {
        name: "Cantidad Vendida",
        type: "bar",
        data: cantidades,
        barGap: "10%",
        barWidth: isMobile ? "35%" : "40%",
        itemStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [
              { offset: 0, color: "#818cf8" },
              { offset: 0.5, color: "#6366f1" },
              { offset: 1, color: "#4f46e5" },
            ],
          },
          borderRadius: [0, isMobile ? 6 : 8, isMobile ? 6 : 8, 0],
          shadowColor: "rgba(99, 102, 241, 0.3)",
          shadowBlur: isMobile ? 6 : 10,
          shadowOffsetX: isMobile ? 2 : 3,
          shadowOffsetY: isMobile ? 2 : 3,
        },
        emphasis: {
          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 1,
              y2: 0,
              colorStops: [
                { offset: 0, color: "#a5b4fc" },
                { offset: 0.5, color: "#818cf8" },
                { offset: 1, color: "#6366f1" },
              ],
            },
            shadowColor: "rgba(99, 102, 241, 0.5)",
            shadowBlur: isMobile ? 12 : 20,
          },
        },
        label: {
          show: !isMobile,
          position: "right",
          color: "#4f46e5",
          fontSize: isTablet ? 10 : 12,
          fontWeight: "bold",
          distance: 8,
        },
      },
      {
        name: "Total Ventas (S/)",
        type: "bar",
        data: totales,
        barWidth: isMobile ? "35%" : "40%",
        itemStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [
              { offset: 0, color: "#fbbf24" },
              { offset: 0.5, color: "#f59e0b" },
              { offset: 1, color: "#d97706" },
            ],
          },
          borderRadius: [0, isMobile ? 6 : 8, isMobile ? 6 : 8, 0],
          shadowColor: "rgba(245, 158, 11, 0.3)",
          shadowBlur: isMobile ? 6 : 10,
          shadowOffsetX: isMobile ? 2 : 3,
          shadowOffsetY: isMobile ? 2 : 3,
        },
        emphasis: {
          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 1,
              y2: 0,
              colorStops: [
                { offset: 0, color: "#fcd34d" },
                { offset: 0.5, color: "#fbbf24" },
                { offset: 1, color: "#f59e0b" },
              ],
            },
            shadowColor: "rgba(245, 158, 11, 0.5)",
            shadowBlur: isMobile ? 12 : 20,
          },
        },
        label: {
          show: !isMobile,
          position: "right",
          color: "#d97706",
          fontSize: isTablet ? 10 : 12,
          fontWeight: "bold",
          distance: 8,
          formatter: (params: any) => `S/ ${params.value.toFixed(0)}`,
        },
      },
    ],
  };
});

const totalVentas = computed(() => {
  return props.data?.data?.reduce((sum, p) => sum + parseFloat(p.totalVentas), 0).toFixed(2) || '0.00';
});

const totalCantidad = computed(() => {
  return props.data?.data?.reduce((sum, p) => sum + p.cantidadVendida, 0) || 0;
});

const productoTop = computed(() => {
  const productos = props.data?.data || [];
  if (productos.length === 0) return null;
  return productos.reduce((max, p) => 
    p.cantidadVendida > max.cantidadVendida ? p : max
  , productos[0]);
});

// Altura dinámica del gráfico
const chartHeight = computed(() => {
  const productCount = props.data?.data.length || 5;
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 640;
  const baseHeight = isMobile ? 60 : 70;
  const minHeight = isMobile ? 350 : 450;
  return `${Math.max(minHeight, productCount * baseHeight + 100)}px`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", null, [
        _createElementVNode("h3", { class: "text-lg sm:text-xl lg:text-2xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mb-1 sm:mb-2" }, " Top Productos Más Vendidos "),
        _createElementVNode("p", { class: "text-xs sm:text-sm text-slate-600 font-medium" }, "Ranking de productos por cantidad vendida")
      ], -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.data?.data?.length || 0) + " Productos ", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(VChart), {
        option: chartOption.value,
        loading: __props.loading,
        style: _normalizeStyle({
          height: chartHeight.value,
          width: '100%',
        }),
        autoresize: ""
      }, null, 8, ["option", "loading", "style"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-9 h-9 sm:w-10 sm:h-10 bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-lg flex items-center justify-center shadow-md flex-shrink-0" }, [
            _createElementVNode("svg", {
              class: "w-4 h-4 sm:w-5 sm:h-5 text-white",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-xs text-indigo-600 font-semibold" }, "Total Unidades", -1)),
            _createElementVNode("p", _hoisted_9, _toDisplayString(totalCantidad.value), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-9 h-9 sm:w-10 sm:h-10 bg-gradient-to-br from-amber-500 to-amber-600 rounded-lg flex items-center justify-center shadow-md flex-shrink-0" }, [
            _createElementVNode("svg", {
              class: "w-4 h-4 sm:w-5 sm:h-5 text-white",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_12, [
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-xs text-amber-600 font-semibold" }, "Total Ventas", -1)),
            _createElementVNode("p", _hoisted_13, "S/ " + _toDisplayString(totalVentas.value), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w-9 h-9 sm:w-10 sm:h-10 bg-gradient-to-br from-purple-500 to-purple-600 rounded-lg flex items-center justify-center shadow-md flex-shrink-0" }, [
            _createElementVNode("svg", {
              class: "w-4 h-4 sm:w-5 sm:h-5 text-white",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_16, [
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-xs text-purple-600 font-semibold" }, "Producto Top", -1)),
            _createElementVNode("p", _hoisted_17, _toDisplayString(productoTop.value?.producto.nombreProducto || 'N/A'), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})